import styled from 'styled-components'

export const HeroContainer = styled.div`
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: 800px;
  position: relative;
  z-index: 1;
`
// .section-hero {
//     background: white;
//     width: min(100%, 1000px);
//     padding: 0 50px;
//     display: grid;
//     grid-template-rows: 100px 1fr 100px;
//     border-radius: 20px;
//     height: 100%;
//   }

//   .hero-wrapper {
//     width: 100%;
//     display: flex;
//     align-items: center;
//   }

//   .hero-copy-container {
//     width: 40%;
//   }

//   .hero-title {
//     font-size: 2.4rem;
//     font-weight: 700;
//     margin-bottom: 20px;
//     color: var(--dark-gray);
//   }

//   .hero-copy {
//     margin-bottom: 30px;
//     color: #6d6d6d;
//     font-size: 14px;
//   }

//   .hero-image {
//     width: 60%;
//   }

//   .hero-image img {
//     width: 100%;
//   }

//   .hero-form-button {
//     width: 150px;
//   }

//   .hero-promo {
//     display: flex;
//     align-items: center;
//   }

//   @media (max-width: 769px) {
//     body {
//       display: block;
//       padding: 0;
//     }
//     .hero-form {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//     }

//     .hero-form-input {
//       width: 100%;
//       margin-right: 0;
//     }

//     .hero-form-button {
//       width: 100%;
//     }

//     .section-hero {
//       height: auto;
//       width: 100%;
//       padding: 0 20px;
//       grid-template-rows: 80px 1fr 80px;
//     }

//     .hero-wrapper {
//       flex-direction: column;
//       justify-content: center;
//     }

//     .hero-image {
//       order: 1;
//       width: 100%;
//     }

//     .hero-copy-container {
//       order: 2;
//       width: 100%;
//       text-align: center;
//     }

//     .hero-title {
//       font-size: 20px;
//     }
//   }
